import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FaArrowLeft, FaArrowCircleLeft } from 'react-icons/fa';
import { Link as RouterLink } from 'react-router-dom';

import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Link,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';

import AssignmentIcon from '@mui/icons-material/Assignment';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';

import './ListaCalibracionesAsis.css';

import {
  getCalibraciones,
  clearErrors,
  deleteCalibracion,
  subirReporteCalibracion,
  deleteDataCalibracion
} from '../../../redux/actions/dataactions';

export class ListaCalibracionesAsis extends Component {
  constructor() {
    super();
    this.state = {
      selectedFile: null,
      progid: '',
      openatach: false,
      open: false,
      opendelete: false,
      fecha: '',
      horainicio: '',
      horafinal: '',
      numcertificado: '',
      reporteurl: '',
      reportefilename: '',
      calibracionid: ''
    };
  }

  componentDidMount() {
    this.props.getCalibraciones(this.props.equipoId);
  }

  // ******************** Ver reporte
  handleOpen = (rawdata) => {
    this.mapUserDetailsToState(rawdata);
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  mapUserDetailsToState = (calibracion) => {
    this.setState({
      fecha: calibracion.fecha ? calibracion.fecha : '',
      horainicio: calibracion.horainicio ? calibracion.horainicio : '',
      horafinal: calibracion.horafinal ? calibracion.horafinal : '',
      numcertificado: calibracion.numcertificado ? calibracion.numcertificado : '',
      reporteurl: calibracion.reporteurl ? calibracion.reporteurl : ''
    });
  };

  render() {
    const { calibraciones, loadingcal } = this.props.data;

    // Columna de acciones (primera) con Tooltip + IconButton
    const columns = [
      {
        field: 'acciones',
        headerName: 'Acciones',
        width: 110, // ancho fijo
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        renderCell: (params) => (
          <Tooltip title="Reporte de Calibración">
            <IconButton
              size="small"
              onClick={() => this.handleOpen(params.row)}
              aria-label="reporte de calibración"
            >
              <AssignmentIcon />
            </IconButton>
          </Tooltip>
        )
      },
      {
        field: 'fecha',
        headerName: 'Fecha',
        width: 140
      },
      {
        field: 'numcertificado',
        headerName: 'No. Certificado',
        width: 170
      },
      {
        field: 'reporteurl',
        headerName: 'Link Certificado',
        width: 220,
        renderCell: (params) =>
          params.value === 'false' ? (
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Sin Certificado Adjunto
            </Typography>
          ) : (
            <Link
              href={params.value}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              sx={{ fontWeight: 500 }}
            >
              Link del Certificado
            </Link>
          )
      }
    ];

    // Mapeo de filas: DataGrid requiere "id"
    const rows = Array.isArray(calibraciones)
      ? calibraciones.map((row, idx) => ({
          id: row.id || row._id || `${row.numcertificado || 'cert'}-${idx}`,
          ...row
        }))
      : [];

    const linkcalibracion =
      this.state.reporteurl === 'false' ? (
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Sin Certificado Adjunto
        </Typography>
      ) : (
        <Link
          href={this.state.reporteurl}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          sx={{ fontWeight: 500 }}
        >
          Link del Certificado
        </Link>
      );

    return (
      <Box className="listamtoprog-container" sx={{ width: '100%' }}>
     
         <Typography sx={{ fontSize: '16px', color: '#03178c', fontWeight: 600, textAlign: 'center', mb: 1 }}>
                                       Calibraciones Realizadas
                                     </Typography>

        <Box className="listamtoprog-table" sx={{ mt: 1 }}>
          {!loadingcal ? (
            <DataGrid
              rows={rows}
              columns={columns}
              disableRowSelectionOnClick
              pageSizeOptions={[5, 10, 20]}
              initialState={{
                pagination: { paginationModel: { pageSize: 10, page: 0 } }
              }}
              
              getRowId={(row) => row.id}
              components={{
                              Toolbar: () => (
                                <Box p={1}>
                                  <GridToolbarQuickFilter placeholder="Buscar..." />
                                </Box>
                              )
                            }}
              sx={{
                height: 500,
                width: '100%',
                mt: 2,
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: 'primary.main',
                  color: 'white'
                },

              }}
            />
          ) : (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: 240
              }}
            >
              <CircularProgress size={50} color="primary" />
            </Box>
          )}
        </Box>

        {/* Dialog de detalle de calibración */}
        <Dialog open={this.state.open} onClose={this.handleClose} fullWidth maxWidth="sm">
          <DialogTitle sx={{ pb: 1 }}>
            <Typography
              sx={{
                fontSize: '20px',
                fontWeight: 600,
                color: '#0468BF',
                textAlign: 'center'
              }}
            >
              Reporte de Calibración
            </Typography>
          </DialogTitle>

          <DialogContent sx={{ pt: 1 }}>
            <Grid container spacing={2} mt={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  required
                  type="date"
                  name="fecha"
                  id="fecha"
                  label="Fecha de Realización"
                  value={this.state.fecha}
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ readOnly: true, min: '2019-01-01', max: '2022-01-01' }}
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  required
                  type="time"
                  name="horainicio"
                  id="horainicio"
                  label="Hora de Inicio"
                  value={this.state.horainicio}
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ readOnly: true, min: '2000-01-01', max: '2022-01-01' }}
                />
              </Grid>

              <Grid item xs={12} sm={3}>
                <TextField
                  required
                  type="time"
                  name="horafinal"
                  id="horafinal"
                  label="Hora Final"
                  value={this.state.horafinal}
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ readOnly: true, min: '2000-01-01', max: '2022-01-01' }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  required
                  type="text"
                  name="numcertificado"
                  id="numcertificado"
                  label="Número del Certificado"
                  value={this.state.numcertificado}
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ readOnly: true }}
                />
              </Grid>

              <Grid item xs={12}>
                {linkcalibracion}
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions sx={{ justifyContent: 'flex-end', pr: 1.5, pb: 1.5 }}>
            <Tooltip title="Cerrar">
              <IconButton onClick={this.handleClose}>
                <FaArrowLeft color="#D3D7DC" />
              </IconButton>
            </Tooltip>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }
}

ListaCalibracionesAsis.propTypes = {
  getCalibraciones: PropTypes.func.isRequired,
  subirReporteCalibracion: PropTypes.func.isRequired,
  deleteCalibracion: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  deleteDataCalibracion: PropTypes.func.isRequired,
  equipoId: PropTypes.any,
  backTo: PropTypes.string
};

const mapActionsToProps = {
  getCalibraciones,
  clearErrors,
  deleteCalibracion,
  deleteDataCalibracion,
  subirReporteCalibracion
};

const mapStateToProps = (state) => ({
  data: state.data,
  UI: state.UI
});

export default connect(mapStateToProps, mapActionsToProps)(ListaCalibracionesAsis);
